import { flexRender, RowData } from "@tanstack/react-table";

import { getHeaderClassName, IRydeHeader } from "@ryde/shared";

import { TableFooterCellReportStyled } from "./footer-cell.reports.styled";

interface IGridRowFooterCellProps<T extends RowData> {
  footer: IRydeHeader<T, unknown>;
}

export const GridTableFooterCellReports = <T extends RowData>({
  footer: header,
}: IGridRowFooterCellProps<T>): JSX.Element => {
  return (
    <TableFooterCellReportStyled
      key={header.id}
      colSpan={header.colSpan}
      className={getHeaderClassName(header)}
    >
      {header.isPlaceholder ? null : (
        <div className="th_content">
          {flexRender(header.column.columnDef.footer, header.getContext())}
        </div>
      )}
    </TableFooterCellReportStyled>
  );
};
